<script lang="ts">
export default {
    name: "ContactForm",
    inheritAttrs: false,
};  
</script>
<script setup lang="ts">
import { useFormsStore } from "@/tiers/frontend/stores/FormsStore"

interface Props {
    forms: any;
}

const props = defineProps<Props>()
const store = useFormsStore()
store.forms = props.forms
</script>
<template>
    <router-view class="view"></router-view>
</template>